import {Component, inject, Input, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {Router} from "@angular/router";
import {AuthService} from "../../services/auth/auth.service";
import {Paths} from "../../paths";
import {StateService} from "../../services/state/state.service";
import {Subscription} from "rxjs";
import {unsubscribe} from "../../libs/utils/epic.utils";
import {OrgDto} from "../../repositories/dto/org.dto";
import {MediaComponent} from "../../libs/media/media/media.component";

@Component({
  selector: 'acc-logo',
  imports: [
    NgOptimizedImage,
    MediaComponent
  ],
  templateUrl: './logo.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logo.component.css'
})
export class LogoComponent implements OnInit, OnDestroy {

  protected readonly logo: string = 'assets/images/logo/acc_transparent_64.webp';

  @Input()
  public showTitle: boolean = true;

  protected title: string | undefined;
  protected org: OrgDto | undefined;

  private readonly router: Router = inject(Router);
  private readonly auth: AuthService = inject(AuthService);
  private readonly stateService: StateService = inject(StateService);
  private readonly subs: Subscription[] = [];

  protected routeMain(): void {
    const path: string = this.auth.isAuthenticated() ? Paths.OVERVIEW : Paths.ROOT;
    this.router.navigate([path]).then();
  }

  ngOnInit(): void {
    this.subs.push(
      this.stateService.getInfo().subscribe((i) => this.title = i.name),
      this.stateService.getOrg().subscribe((o) => this.org = o)
    );
  }

  ngOnDestroy(): void {
    unsubscribe(this.subs);
  }

  protected isShowTitle(): boolean {
    return !!(!this.isShowLogo() && this.showTitle && this.title);
  }

  // If the logo is in landscape format and the dimensions fit, then show the logo
  protected isShowLogo(): boolean {
    return false;
    // TODO return !!(this.org && this.org.logoId);
  }
}
